"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NToken__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_punkers",
                type: "address",
            },
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
            {
                internalType: "contract IDescriptorMinimal",
                name: "_descriptor",
                type: "address",
            },
            {
                internalType: "contract ISeeder",
                name: "_seeder",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "fromDelegate",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "toDelegate",
                type: "address",
            },
        ],
        name: "DelegateChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegate",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "previousBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBalance",
                type: "uint256",
            },
        ],
        name: "DelegateVotesChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DescriptorLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract IDescriptorMinimal",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "DescriptorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "IdShiftLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newIdShift",
                type: "uint256",
            },
        ],
        name: "IdShiftUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "MetadataLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "symbol",
                type: "string",
            },
        ],
        name: "MetadataUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "MinterLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "minter",
                type: "address",
            },
        ],
        name: "MinterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "PunkBurned",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "punkType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "skinTone",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "uint16",
                                name: "accType",
                                type: "uint16",
                            },
                            {
                                internalType: "uint16",
                                name: "accId",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct ISeeder.Accessory[]",
                        name: "accessories",
                        type: "tuple[]",
                    },
                ],
                indexed: false,
                internalType: "struct ISeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "PunkCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "punkers",
                type: "address",
            },
        ],
        name: "PunkersUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "RegisterOGHashesLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "SeederLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ISeeder",
                name: "seeder",
                type: "address",
            },
        ],
        name: "SeederUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DELEGATION_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "punkId",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "punkType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "skinTone",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "uint16",
                                name: "accType",
                                type: "uint16",
                            },
                            {
                                internalType: "uint16",
                                name: "accId",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct ISeeder.Accessory[]",
                        name: "accessories",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct ISeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "calculateSeedHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        name: "checkpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "fromBlock",
                type: "uint32",
            },
            {
                internalType: "uint96",
                name: "votes",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "contractURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
        ],
        name: "delegate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "expiry",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "delegateBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "delegates",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "descriptor",
        outputs: [
            {
                internalType: "contract IDescriptorMinimal",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getCurrentVotes",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "getPriorVotes",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "punkId",
                type: "uint256",
            },
        ],
        name: "getPunk",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "punkType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "skinTone",
                        type: "uint8",
                    },
                    {
                        components: [
                            {
                                internalType: "uint16",
                                name: "accType",
                                type: "uint16",
                            },
                            {
                                internalType: "uint16",
                                name: "accId",
                                type: "uint16",
                            },
                        ],
                        internalType: "struct ISeeder.Accessory[]",
                        name: "accessories",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct ISeeder.Seed",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDescriptorLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isIdShitLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isMetadataLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isMinterLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isRegisterOGHashesLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isSeederLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockIdShift",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockRegisterOGHashes",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "numCheckpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "punkers",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32[]",
                name: "hashes",
                type: "bytes32[]",
            },
        ],
        name: "registerOGHashes",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "seeder",
        outputs: [
            {
                internalType: "contract ISeeder",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "punkId",
                type: "uint256",
            },
        ],
        name: "seeds",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "newContractURIHash",
                type: "string",
            },
        ],
        name: "setContractURIHash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IDescriptorMinimal",
                name: "_descriptor",
                type: "address",
            },
        ],
        name: "setDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newIdShift",
                type: "uint256",
            },
        ],
        name: "setIdShift",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "setMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
        ],
        name: "setName",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_punkers",
                type: "address",
            },
        ],
        name: "setPunkers",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISeeder",
                name: "_seeder",
                type: "address",
            },
        ],
        name: "setSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
        ],
        name: "setSymbol",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "votesToDelegate",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NToken__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_punkers, _minter, _descriptor, _seeder, overrides) {
        return super.deploy(_punkers, _minter, _descriptor, _seeder, overrides || {});
    }
    getDeployTransaction(_punkers, _minter, _descriptor, _seeder, overrides) {
        return super.getDeployTransaction(_punkers, _minter, _descriptor, _seeder, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NToken__factory = NToken__factory;
NToken__factory.bytecode = _bytecode;
NToken__factory.abi = _abi;
